module.exports = __webpack_public_path__ + "static/media/white-clubs.c3ab8c75.svg";